import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  AllGroupMenuType,
  LoginResponseType,
} from "../../redux/auth/authTypes";
import {
  ServicesActive,
  ServicesInactive,
  AssignColumnsActive,
  AssignColumnsInactive,
  InvoiceColumnsInactive,
  InvoiceColumnsActive,
  AssignClientsActive,
  AssignClientsInactive,
  OpenItemsActive,
  OpenItemsInactive,
  AdminReportsActive,
  AdminReportsInactive,
  UsersClientsActive,
  UsersClientsInactive,
  ChangeCredentialsActive,
  ChangeCredentialsInactive,
  HomeActive,
  HomeInactive,
  UserManagementInactive,
  UserManagementActive,
  OpenJobsActive,
  OpenJobsInactive,
  IdPasswordActive,
  IdPasswordInactive,
  MaintenanceInactive,
  MaintenanceActive,
  DisbursementActiveIcon,
  DisbursementInactiveIcon,
  ClientDirectoryInActiveIcon,
  ClientDirectoryActiveIcon,
  MasterDataActiveIcon,
  MasterDataInActiveIcon,
  TimeSheetActiveIcon,
  TimeSheetInActiveIcon,
  DoubleArrow,
  ProjExelLogo,
  FinacLogoSmall,
  TimeSheetReportActiveIcon,
  TimeSheetReportInActiveIcon,
  JobsInactiveIcon,
  JobsActiveIcon,
  ComplianceCalendarIcon,
  ComplianceCalendarActiveIcon,
  LeadModuleActiveIcon,
  LeadModuleInActiveIcon,
  HelpModuleIcon,
  HelpModuleActiveIcon,
  SchedulingActiveIcon,
  SchedulingIcon,
} from "../../assets/images";
import {
  ADMIN_MENU,
  USER_MENU,
  EXTRA_MENU,
  EXTERNAL_MENU,
  CLIENT_MENU,
} from "../../constant/menu";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Divider } from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';

type AppProps = {
  loginData: LoginResponseType;
  name?: string;
  sideMenus: any[];
  allGroupMenus: [] | AllGroupMenuType[];
  toggle: boolean;
  handleToggle: any;
};

const MobileMenu = ({
  loginData,
  name,
  sideMenus,
  allGroupMenus,
  toggle,
  handleToggle,
}: AppProps) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (isOpen: any) => (event: any) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(isOpen);
  };

  const { user_role_id, is_client } = loginData;

  const getMenuList = () => {
    switch (user_role_id) {
      case 1:
        return ADMIN_MENU;
      default:
        if (is_client === 0) {
          return USER_MENU;
        } else {
          return CLIENT_MENU;
        }
    }
  };

  const returnIcon = (iconName: string) => {
    switch (iconName) {
      case "HomeInactive":
        return HomeInactive;
      case "HomeActive":
        return HomeActive;
      case "ServicesActive":
        return ServicesActive;
      case "ServicesInactive":
        return ServicesInactive;
      case "AssignColumnsInactive":
        return AssignColumnsInactive;
      case "AssignColumnsActive":
        return AssignColumnsActive;
      case "InvoiceColumnsInactive":
        return InvoiceColumnsInactive;
      case "InvoiceColumnsActive":
        return InvoiceColumnsActive;
      case "AssignClientsInactive":
        return AssignClientsInactive;
      case "AssignClientsActive":
        return AssignClientsActive;
      case "OpenItemsInactive":
        return OpenItemsInactive;
      case "OpenItemsActive":
        return OpenItemsActive;
      case "AdminReportsInactive":
        return AdminReportsInactive;
      case "AdminReportsActive":
        return AdminReportsActive;
      case "UsersClientsInactive":
        return UsersClientsInactive;
      case "UsersClientsActive":
        return UsersClientsActive;
      case "ChangeCredentialsInactive":
        return ChangeCredentialsInactive;
      case "ChangeCredentialsActive":
        return ChangeCredentialsActive;
      case "UserManagementInactive":
        return UserManagementInactive;
      case "UserManagementActive":
        return UserManagementActive;
      case "OpenJobsActive":
        return OpenJobsActive;
      case "OpenJobsInactive":
        return OpenJobsInactive;
      case "IdPasswordActive":
        return IdPasswordActive;
      case "IdPasswordInactive":
        return IdPasswordInactive;
      case "MaintenanceInactive":
        return MaintenanceInactive;
      case "MaintenanceActive":
        return MaintenanceActive;
      case "DisbursementActiveIcon":
        return DisbursementActiveIcon;
      case "DisbursementInactiveIcon":
        return DisbursementInactiveIcon;
      case "ClientDirectoryActiveIcon":
        return ClientDirectoryActiveIcon;
      case "ClientDirectoryInActiveIcon":
        return ClientDirectoryInActiveIcon;
      case "activeMasterIcon":
        return MasterDataActiveIcon;
      case "inActiveMasterIcon":
        return MasterDataInActiveIcon;
      case "TimeSheetActiveIcon":
        return TimeSheetActiveIcon;
      case "TimeSheetInActiveIcon":
        return TimeSheetInActiveIcon;
      case "TimeSheetReportActiveIcon":
        return TimeSheetReportActiveIcon;
      case "TimeSheetReportInActiveIcon":
        return TimeSheetReportInActiveIcon;
      case "JobsInactiveIcon":
        return JobsInactiveIcon;
      case "JobsActiveIcon":
        return JobsActiveIcon;
      case "ComlianceCalendarIcon":
        return ComplianceCalendarIcon;
      case "ComlianceCalendarActiveIcon":
        return ComplianceCalendarActiveIcon;
      case "LeadModuleActiveIcon":
        return LeadModuleActiveIcon;
      case "LeadModuleInActiveIcon":
        return LeadModuleInActiveIcon;
      case "HelpModuleIcon":
        return HelpModuleIcon;
      case "HelpModuleActiveIcon":
        return HelpModuleActiveIcon;
      case "SchedulingActiveIcon":
        return SchedulingActiveIcon;
      case "SchedulingIcon":
        return SchedulingIcon;

      default:
        return "";
    }
  };

  const menuList =
    sideMenus?.length > 0 &&
    sideMenus?.map((link: any, index: number) => {
      return (
        <ListItem key={`${index}${link}`}>
          {
            <NavLink
              to={link.front_end_route}
              exact
              style={
                name === link.finac_key
                  ? {
                      borderRight: "3px solid #dd4433",
                      color: "#223035",
                      textDecoration: "none",
                      borderRadius: "6px",
                      borderTopRightRadius: "0",
                      borderBottomRightRadius: "0",
                      background: "rgba(221, 68, 51, 0.1)",
                      padding: "5px",
                      width: "100%",
                    }
                  : { cursor: "pointer" }
              }
            >
              {name === link.finac_key ? (
                <img src={returnIcon(link.active_icon)} />
              ) : (
                <img src={returnIcon(link.icon)} />
              )}
              {
                <span
                  className={`ml-3 ${link.comingSoon ? "text-muted" : null}`}
                  style={{ color: "#484848" }}
                >
                  {link.menu_name}
                </span>
              }
              <br />
            </NavLink>
          }
        </ListItem>
      );
    });

  const extraMenuList = EXTRA_MENU.map((link: any, index: number) => {
    return (
      <ListItem key={`${index}${link}`}>
        <NavLink
          to={link.to}
          exact
          activeClassName={name === link.key ? "active" : ""}
          style={{ cursor: "pointer" }}
        >
          <img
            src={name === link.key ? link.activeIcon : link.icon}
            alt="link icon"
          />

          {<span className="ml-3">{link.title}</span>}
        </NavLink>
      </ListItem>
    );
  });

  const externalMenuList = EXTERNAL_MENU.map((link: any, index: number) => {
    return (
      <ListItem key={index}>
        <a
          href={link.externalLink}
          target="_blank"
          style={{
            cursor: "pointer",
            color: "#484848",
            textDecoration: "none",
            display: "block",
            // font-family: {$fontFamily};
            fontWeight: "500",
            fontSize: "14px",
            boxSizing: "border-box",
            borderLeft: "1px solid transparent",
            marginTop: "1px",
          }}
        >
          <span>{link.icon}</span>
          <span style={{ paddingLeft: "10px" }}>{link.title}</span>
        </a>
      </ListItem>
    );
  });

  return (
    <div className="mobile-menu">
      <IconButton
        onClick={toggleDrawer(true)}
        sx={{ display: { sm: "none" }, zIndex: 1000, mt: 1 ,paddingLeft:"20px"}}
      >
        {<i className="las la-bars"></i>}
      </IconButton>
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        <List>
          {
            <ListItem style={{ display: "flex", justifyContent: "flex-start" }}>
              {
                <img
                  src={FinacLogoSmall}
                  alt="ProjExel Logo"
                  className="logo mt-0"
                  style={{ width: "32px" }}
                />
              }
            </ListItem>
          }
          {menuList}
        </List>
        <Divider />
        <List>
          {extraMenuList}
          {externalMenuList}
        </List>
      </Drawer>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  loginData: state.auth.loginData,
  sideMenus: state.auth.sideMenus,
  allGroupMenus: state.auth.allGroupMenus,
});

export default connect(mapStateToProps)(MobileMenu);
